/**
 * @desc getAccessToken
 */
const URL = "/rantion-auth";
import http, { updateResponse } from "@/http";
export function request(body: defs.auth.ServiceTicketRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/serviceTicket/accessToken`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
